import { createApp } from 'vue';
import { createYmaps } from 'vue-yandex-maps';

import MapApp from './map-component.vue';

export function mapComponent(container, navigation) {
	if (container) {
		const mapApp = createApp(MapApp, { navigation, href: container.dataset.href || undefined});

		mapApp.use(createYmaps({
			apikey: '2ea39fee-531d-4fd4-8f2c-7a6cd768ee7b',
			lang: 'ru_RU',
		}));

		mapApp.mount(container);
	}
}
